





















import { Component, Prop, Vue, Watch } from "vue-property-decorator";
import CBlock from "@/components/form/CustomPage/CBlock.vue";
import CField from "@/components/form/CField.vue";
import EditorWithFile from "@/components/EditorWithFile.vue";
import CSingleSelect from "@/components/form/CSingleSelect.vue";
import { CourseInfoEdit as ICourseInfoEdit } from "@/api-v2/course/models";

@Component({
  components: {
    CSingleSelect,
    EditorWithFile,
    CBlock,
    CField
  }
})
export default class CourseInfoForm extends Vue {
  @Prop() documentInfo!: ICourseInfoEdit;

  documentForm: ICourseInfoEdit = {
    hours: 0,
    price: 0
  };

  @Watch("documentForm", { immediate: true, deep: true })
  checkDocumentForm() {
    this.documentForm.price = this.documentForm.price
      ? this.documentForm.price
      : 0;
    this.documentForm.hours = this.documentForm.hours
      ? +this.documentForm.hours
      : 0;
    this.$emit("input", this.documentForm);
  }

  created() {
    this.documentForm = this.documentInfo;
    if (this.documentInfo.price) {
      this.documentForm.price = this.documentInfo.price;
    }
  }
}
